module.exports = "<!-- View/routes wrapper-->\r\n<div class=\"user-layout-container text-center animated fadeInDown\">\r\n    <div>\r\n        <div>\r\n            <h1 class=\"logo-name\">{{ 'product-name' | translate | uppercase }}</h1>\r\n        </div>\r\n        <div class=\"content-wrapper\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n</div>\r\n<p class=\"copyright\"><small>{{'product-name' | translate}} &copy; 2017</small> </p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/userLayout.component.html
// module id = ./src/app/components/common/layouts/userLayout.component.html
// module chunks = main